import { SVGProps } from 'react';

const Fuel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.887 21.168h11.547M3.849 8.658h9.623m0 12.51V3.848a1.925 1.925 0 0 0-1.925-1.925H5.773A1.924 1.924 0 0 0 3.85 3.848v17.32m9.623-8.66h1.924a1.924 1.924 0 0 1 1.924 1.924v1.925a1.925 1.925 0 0 0 3.85 0v-6.9a1.92 1.92 0 0 0-.568-1.366L17.32 4.81"
    />
  </svg>
);
export default Fuel;
